import featuredImage1 from "../../../src/img/CaseImage1.svg";
import featuredImage2 from "../../../src/img/CaseImage2.svg";
import featuredImage3 from "../../../src/img/CaseImage3.svg";
import content from "../../Content/content";

export const CARD = [
    {
        key: "test1",
        img: featuredImage1,
        header: content.newsroom.featuredNews.test1Header,
        alt: "First test image alternative"
    },
    {
        key: "test2",
        img: featuredImage2,
        header: content.newsroom.featuredNews.test2Header,
        alt: "Second test image alternative"
    },
    {
        key: "test3",
        img: featuredImage3,
        header: content.newsroom.featuredNews.test3Header,
        alt: "Third test image alternative"
    },
    {
        key: "test4",
        img: featuredImage1,
        header: content.home.caseStudies.test4Header,
        alt: "Fourth test image alternative"
    },
    {
        key: "test5",
        img: featuredImage2,
        header: "Test Case 5",
        alt: "Fifth test image alternative"
    },
    {
        key: "test6",
        img: featuredImage3,
        header: "Test Case 6",
        alt: "Sixth test image alternative"
    }
];